import { useTranslation } from 'react-i18next';
import { useEffect, useState, useCallback } from 'react';
import { ChannelsService } from '../../../services/channels.service';
import { ProvidersService } from '../../../services/providers.service';
import { AlertService } from '../../../services/alert.service';
import Header from '../../../components/layout/header.component';
import Asaid from '../../../components/layout/asaid.component';
import Footer from '../../../components/layout/footer.component';
import useBgPages from '../../../hooks/use-bg-pages.hook';
import OutputsModal from './modal/outputs.modal';
import Datatable from '../../../components/datatable/datatable.component';
import useRequest from '../../../hooks/use-request.hook';
import MasksModal from './modal/masks.modal';
import Icon from '../../../components/forms/icon.component';
import ActionsDropdown from '../../../components/datatable/actions-dropdown.component';
import PrincipalCard from '../../../components/cards/principal-card.component';
import LogData from '../../../components/logs/log-data.component';
import { useSession } from '../../../hooks/use-session.hook';
import { PROFILES } from '../../../constants';
import SendMessageModalSMS from './modal/send.message.modal';

interface Data {
  _id: string;
  created_at: string;
  is_international: boolean;
  updated_at: string;
  status: boolean;
  provider: string;
  telcel: Array<{ sms_masks: string; priority: number }>;
  movistar: Array<{ sms_masks: string; priority: number }>;
  att: Array<{ sms_masks: string; priority: number }>;
  other: Array<{ sms_masks: string; priority: number }>;
  name: string;
  carriers: Array<string>;
  settings: Array<string>;
}

const ActionCell = ({ rows, handleEdit, handleChangeStatus, options }: any) => (
  <ActionsDropdown
    edit={() => handleEdit(rows)}
    changeStatus={() => handleChangeStatus(rows)}
    rowStatus={rows.status}
    options={options}
  />
);

function ChannelSMSPage() {
  useBgPages();
  const { t } = useTranslation();
  const { call, isRequesting } = useRequest();
  const [totalRegistersMasks, setTotalRegistersMasks] = useState<number>(0);
  const { session, selectedAccount } = useSession();
  const [totalMasks, setTotalMasks] = useState<number>(0);
  const [totalInternational, setTotalInternational] = useState<number>(0);
  const [totalRegistersOutputs, setTotalRegistersOutputs] = useState<number>(0);
  const [totalOutputs, setTotalOutputs] = useState<number>(0);
  const [providers, setProviders] = useState<any[]>([]);
  const [masks, setMasks] = useState<Data[]>([]);
  const [masksCatalogue, setMasksCatalogue] = useState<{ [key: string]: Array<any> }>({});
  const [outputs, setOutputs] = useState<Data[]>([]);
  const [activeTab, setActiveTab] = useState(
    session.profile === PROFILES.ADMIN ? 'tabTwo' : 'tabOne'
  );
  const [showModalAgent, setShowModalAgent] = useState({
    show: false,
    data: null
  });
  const [showModalOutputs, setShowModalOutputs] = useState({
    show: false,
    data: null
  });
  const [showModalSendMessage, setShowModalSendMessage] = useState({
    show: false,
    data: null
  });

  const dataStatisticsOutputs = [
    { label: 'Registros', total: totalRegistersOutputs, type: '', icon: 'ki-book-open' },
    { label: 'Activos', total: totalOutputs, type: 'primary', icon: 'ki-check-circle' },
    { label: 'Internacional', total: totalInternational, type: 'info', icon: 'ki-abstract-39' }
  ];

  const dataStatisticsMasks = [
    { label: 'Registros', total: totalRegistersMasks, type: '', icon: 'ki-book-open' },
    { label: 'Activos', total: totalMasks, type: 'primary', icon: 'ki-check-circle' }
  ];

  const tabSMS =
    session.profile === PROFILES.ADMIN
      ? [{ key: 'tabTwo', label: 'Máscaras' }]
      : [
          { key: 'tabOne', label: 'Salidas' },
          { key: 'tabTwo', label: 'Máscaras' }
        ];

  const operators = [
    {
      name: 'telcel',
      img: '/assets/media/operators/telcel.png',
      imgDark: '/assets/media/operators/telcel-dark.png',
      width: '60px',
      height: '15px'
    },
    {
      name: 'movistar',
      img: '/assets/media/operators/movistar.png',
      imgDark: '/assets/media/operators/movistar-dark.png',
      width: '60em',
      height: '15px'
    },
    {
      name: 'att',
      img: '/assets/media/operators/att.png',
      imgDark: '/assets/media/operators/att-dark.png',
      width: '55em',
      height: '22px'
    },
    {
      name: 'altan',
      img: '/assets/media/operators/altan.png',
      imgDark: '/assets/media/operators/altan-dark.png',
      width: '50em',
      height: '22px'
    }
  ];

  const renderOutputInfo = (row: any) => (
    <ul className="list-group-item">
      <li>
        <div className="d-flex flex-column">
          <div className="w-100 mb-1">
            <strong className="fs-6">{t('channels.rcs.tc-name')}:</strong>
            <span className="ms-1">{row.name || t('general.no-info')}</span>
          </div>
          <div className="w-100 mb-1">
            <strong className="fs-6">Tipo Salida:</strong>
            <span className="ms-1">
              {t(row?.is_international ? 'channels.rcs.international' : 'channels.rcs.nacional') ||
                t('general.no-info')}
            </span>
          </div>
        </div>
      </li>
    </ul>
  );

  const renderProviderInfo = (rows: any) => {
    if (!rows.provider) return null;
    return (
      <div className="d-flex align-items-center">
        <span className="ms-2 fs-6">
          <strong>{rows.provider.name}</strong>
        </span>
      </div>
    );
  };

  const renderOperators = (rows: any, operators: any[]) => {
    if (!rows.operators || !Array.isArray(rows.operators)) return null;

    return (
      <div className="d-flex justify-content-start align-items-center pb-5 px-0 overflow-auto">
        <ul className="nav nav-pills nav-pills-custom mb-3 d-flex flex-nowrap">
          {operators.map((operator) => {
            const isActive = rows.is_international
              ? operator.name === 'altan' || operator.name === 'other'
              : rows.operators?.includes(operator.name) ||
                (operator.name === 'altan' && rows.operators?.includes('other'));

            return (
              <li className="nav-item mb-3 me-3 me-lg-3" key={operator.name}>
                <div
                  className="nav-link pe-none cursor-default btn btn-outline btn-flex btn-active-color-primary flex-column overflow-hidden w-70px h-50px pt-3 pb-2 active"
                  data-bs-toggle="pill"
                  id={`kt_charts_widget_10_tab_${operator.name}`}
                >
                  <div className="mb-3">
                    <span className="theme-light-show">
                      <img
                        alt="operator"
                        title="img"
                        src={operator.img}
                        width={operator.width}
                        height={operator.height}
                      />
                    </span>
                    <span className="theme-dark-show">
                      <img
                        alt="operator"
                        title="img"
                        src={operator.imgDark}
                        width={operator.width}
                        height={operator.height}
                      />
                    </span>
                  </div>
                  <span
                    className={`bullet-custom position-absolute bottom-0 w-100 h-4px ${
                      isActive ? 'bg-primary' : 'bg-danger'
                    }`}
                  />
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  const renderStatusBadge = (status: boolean | null) => {
    if (status === true) {
      return (
        <span className="badge text-dark fs-5">
          <Icon icon="ki-check-circle" size="fs-3" type="primary" />
          {t('general.active')}
        </span>
      );
    } else if (status === false) {
      return (
        <span className="badge text-dark fs-5">
          <Icon icon="ki-minus-circle" size="fs-3" type="danger" />
          {t('general.inactive')}
        </span>
      );
    } else {
      return (
        <span className="text-gray-700 badge bg-secondary fs-6">
          <Icon icon="ki-information" size="fs-2" className="me-1" type="danger" />
          {t('general.no-info')}
        </span>
      );
    }
  };

  const handleEdit = (rows: any) => {
    setShowModalOutputs({ show: true, data: rows });
  };

  const handleChangeStatus = (rows: any) => {
    changeOutputStatus(rows._id, 'changeStatusOuputs-7722634544', rows.status);
  };

  const handleShowModalSendMessage = async (refresh: boolean) => {
    if (refresh) {
      await getOuputs();
    }
    setShowModalSendMessage({ show: false, data: null });
  };

  const renderActionCell = useCallback(
    (rows: any) => {
      const options =
        rows.status !== false
          ? [
              {
                label: t('channels.rcs.send-message-text'),
                icon: 'ki-send',
                color: 'primary',
                onClick: () => setShowModalSendMessage({ show: true, data: rows })
              }
            ]
          : [];
      return (
        <ActionCell
          rows={rows}
          handleEdit={handleEdit}
          handleChangeStatus={handleChangeStatus}
          options={options}
        />
      );
    },
    [handleEdit, handleChangeStatus]
  );

  const columnsOutputs = [
    {
      name: 'Información salida',
      sortable: true,
      selector: (r: any) => `${r.name} ${r.is_international}`,
      width: 25,
      cell: renderOutputInfo
    },
    {
      name: t('channels.rcs.agent-tc-2'),
      sortable: true,
      selector: (r: any) => `${r.provider.name}`,
      width: 15,
      cell: renderProviderInfo
    },
    {
      name: t('channels.rcs.agent-tc-3'),
      sortable: true,
      selector: (r: any) => `${r.operators}`,
      width: 35,
      cell: (rows: any) => renderOperators(rows, operators)
    },
    {
      name: t('roles.title-column-3'),
      sortable: true,
      selector: (r: any) => `${r.status}`,
      width: 20,
      cell: (rows: any) => renderStatusBadge(rows.status)
    },
    {
      name: t('general.acctions'),
      sortable: true,
      selector: (r: any) => `${r._id}`,
      exportable: false,
      cell: renderActionCell
    }
  ];

  const renderMaskInfo = (rows: any) => (
    <ul className="list-group-item">
      <li>
        <div className="d-flex flex-column">
          <div className="w-100 mb-1">
            <strong className="fs-6">{t('channels.rcs.tc-name')}:</strong>
            <span className="ms-1">{rows.name || t('general.no-info')}</span>
          </div>
          <div className="w-100 mb-1">
            <strong className="fs-6">Tipo Salida:</strong>
            <span className="ms-1">
              {t(rows?.is_international ? 'channels.rcs.international' : 'channels.rcs.nacional') ||
                t('general.no-info')}
            </span>
          </div>
        </div>
      </li>
    </ul>
  );

  const renderLine = (label: string, count: number) =>
    count > 0 && (
      <div className="mb-1">
        <strong>{label}:</strong>{' '}
        <span className="ms-1">
          {t('channels.rcs.outputs')} {count}
        </span>
      </div>
    );

  const getCount = (key: string, rows: any) => (Array.isArray(rows[key]) ? rows[key].length : 0);

  const renderOutputData = (rows: any) => {
    const outputData = [
      { label: 'Telcel', key: 'telcel' },
      { label: 'Movistar', key: 'movistar' },
      { label: 'ATT', key: 'att' },
      {
        label: rows.is_international ? t('channels.rcs.international') : 'Otros',
        key: rows.is_international ? 'international' : 'other'
      }
    ];
    return (
      <div className="d-flex flex-column fs-5 text-nowrap">
        {outputData.map(({ label, key }) => renderLine(label, getCount(key, rows)))}
      </div>
    );
  };

  const renderOperatorList = (rows: any, operators: any) => {
    return (
      <div className="d-flex justify-content-start align-items-center pb-5 px-0 overflow-auto">
        <ul className="nav nav-pills nav-pills-custom mb-3 d-flex flex-nowrap">
          {operators.map((operator: any) => {
            const isActive = rows.is_international
              ? operator.name === 'altan' || operator.name === 'other'
              : (Array.isArray(rows[operator.name]) && rows[operator.name].length > 0) ||
                (operator.name === 'altan' && Array.isArray(rows.other) && rows.other.length > 0);

            return (
              <li className="nav-item mb-3 me-3 me-lg-3" key={operator.name}>
                <span
                  className="nav-link btn btn-outline btn-flex btn-active-color-primary flex-column overflow-hidden w-70px h-50px pt-3 pb-2 active"
                  data-bs-toggle="pill"
                  id={`kt_charts_widget_10_tab_${operator.name}`}
                >
                  <div className="mb-3">
                    <span className="theme-light-show">
                      <img
                        title="img"
                        alt="operator"
                        src={operator.img}
                        width={operator.width}
                        height={operator.height}
                      />
                    </span>
                    <span className="theme-dark-show">
                      <img
                        alt="operator"
                        title="img"
                        src={operator.imgDark}
                        width={operator.width}
                        height={operator.height}
                      />
                    </span>
                  </div>
                  <span
                    className={`bullet-custom position-absolute bottom-0 w-100 h-4px ${
                      isActive ? 'bg-primary' : 'bg-danger'
                    }`}
                  />
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  const renderStatusBadgeMasks = (rows: any) => {
    return rows.status ? (
      <span className="badge text-dark fs-5">
        <Icon icon="ki-check-circle" size="fs-3" type="primary" />
        {t('general.active')}
      </span>
    ) : (
      <span className="badge text-dark fs-5">
        <Icon icon="ki-minus-circle" size="fs-3" type="danger" />
        {t('general.inactive')}
      </span>
    );
  };

  const handleActions = (rows: any) => (
    <ActionsDropdown
      edit={() => setShowModalAgent({ show: true, data: rows })}
      changeStatus={() => changeMasksStatus(rows._id, 'changeStatusMasks-9393837344', rows.status)}
      rowStatus={rows.status}
    />
  );

  const columnsMasks = [
    {
      name: 'Información máscara',
      sortable: true,
      selector: (r: any) => `${r.name} ${r.is_international}`,
      width: 25,
      cell: (rows: any) => renderMaskInfo(rows)
    },
    {
      name: t('channels.rcs.outputs'),
      sortable: true,
      selector: (r: any) => `${r.att} ${r.movistar} ${r.telcel} ${r.other}`,
      width: 25,
      cell: (rows: any) => renderOutputData(rows)
    },
    {
      name: t('channels.rcs.agent-tc-3'),
      sortable: true,
      selector: (r: any) => `${r.att} ${r.movistar} ${r.telcel} ${r.other}`,
      width: 35,
      cell: (rows: any) => renderOperatorList(rows, operators)
    },
    {
      name: t('roles.title-column-3'),
      sortable: true,
      selector: (r: any) => `${r.status}`,
      width: 13,
      cell: (rows: any) => renderStatusBadgeMasks(rows)
    },
    ...(session.profile === PROFILES.ROOT
      ? [
          {
            name: t('general.acctions'),
            sortable: true,
            selector: (r: any) => `${r._id}`,
            exportable: false,
            width: 20,
            cell: (rows: any) => handleActions(rows)
          }
        ]
      : [])
  ];

  const getOuputs = async () => {
    try {
      const response = await call(() => ChannelsService.getOutputsSMS());
      const channelsData: Data[] = response;
      setTotalOutputs(channelsData.filter((channel) => channel.status === true).length);
      setTotalInternational(
        channelsData.filter((channel) => channel.is_international === true).length
      );
      setTotalRegistersOutputs(channelsData.length);
      setOutputs(channelsData);
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const getOutputsCatalogue = async () => {
    try {
      const data: any = await call(() => ChannelsService.getOutputsSMS());
      const catalogue: { [key: string]: Array<any> } = {};

      data.forEach((item: any) => {
        if (!item.status) return;

        const { _id, name, operators, is_international } = item;

        if (Array.isArray(operators) && operators.length > 0) {
          operators.forEach((provider: string) => {
            if (!catalogue[provider]) {
              catalogue[provider] = [];
            }
            catalogue[provider].push({ _id, name, is_international });
          });
        }

        if (is_international && (!Array.isArray(operators) || operators.length === 0)) {
          if (!catalogue['other']) {
            catalogue['other'] = [];
          }
          catalogue['other'].push({ _id, name, is_international });
        }
      });

      setMasksCatalogue(catalogue);
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const getMasks = async () => {
    try {
      if (session.profile === PROFILES.ROOT) {
        const response = await call(() => ChannelsService.getMasksSMS());
        const masksData: Data[] = response;
        setTotalMasks(masksData.filter((channel) => channel.status === true).length);
        setTotalRegistersMasks(masksData.length);
        setMasks(masksData);
      } else if (session.profile === PROFILES.ADMIN) {
        const response = await call(() =>
          ChannelsService.getMasksSMSForAccount(selectedAccount.account_id)
        );
        const masksData: Data[] = response;
        setTotalMasks(masksData.filter((channel) => channel.status === true).length);
        setTotalRegistersMasks(masksData.length);
        setMasks(masksData);
      }
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const getProviders = async () => {
    try {
      const data = await ProvidersService.getProvidersSMS();
      setProviders(
        data.map((item: any) => ({
          value: item._id,
          label: item.name,
          type: item.type,
          settings: item.settings_definition
        }))
      );
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const changeMasksStatus = async (id: string, buttonId: string, status: boolean) => {
    const messageQuestion = status
      ? '¿Deseas desactivar esta máscara?'
      : '¿Deseas activar esta máscara?';
    const isConfirmed = await AlertService.question(
      t('general.atention'),
      messageQuestion + '<br><br>',
      () => Promise.resolve(true)
    );
    if (!isConfirmed) return;

    status = !status;
    try {
      await call(() => ChannelsService.changeStatusMasks({ id: id, status }));
      AlertService.toastSuccess('¡ Éxito !, se cambio el status de tu máscara correctamente');
      await getMasks();
      await getOuputs();
      await getOutputsCatalogue();
      LogData({ id: id, status: status ? 'enable' : 'disable' }, buttonId, window.location.href);
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const changeOutputStatus = async (id: string, buttonId: string, status: boolean) => {
    const messageQuestion = status
      ? '¿Deseas desactivar esta salida?'
      : '¿Deseas activar esta salida?';

    const isConfirmed = await AlertService.question(
      t('general.atention'),
      messageQuestion + '<br><br>',
      () => Promise.resolve(true)
    );
    if (!isConfirmed) return;

    status = !status;
    try {
      await call(() => ChannelsService.changeOutputStatusSMS({ id, status }));
      AlertService.toastSuccess('¡ Éxito !, se cambio el status de tu salida correctamente');
      await getMasks();
      await getOuputs();
      await getOutputsCatalogue();
      LogData({ id: id, status: status ? 'enable' : 'sibale' }, buttonId, window.location.href);
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const handleShowModalAgent = async (refresh: boolean) => {
    if (refresh) {
      await getMasks();
    }
    setShowModalAgent({ show: false, data: null });
  };

  const handleShowModalChannel = async (refresh: boolean) => {
    if (refresh) {
      await getOuputs();
    }
    setShowModalOutputs({ show: false, data: null });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getOutputsCatalogue();
        await getProviders();
        await getOuputs();
        await getMasks();
      } catch (error: any) {
        AlertService.toastError(t('general.atention'), error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="page d-flex flex-row flex-column-fluid">
        <Asaid />
        <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
          <Header />
          <div className="content fs-4 d-flex flex-column flex-column-fluid" id="kt_content">
            <div className="post fs-4 d-flex flex-column-fluid" id="kt_post">
              <div className="container-xxl">
                <PrincipalCard
                  dataStatistics={
                    activeTab === 'tabOne' ? dataStatisticsOutputs : dataStatisticsMasks
                  }
                  btnCreate={session.profile === PROFILES.ROOT}
                  onClick={
                    activeTab === 'tabOne'
                      ? () => setShowModalOutputs({ show: true, data: null })
                      : () => (setShowModalAgent({ show: true, data: null }), getOutputsCatalogue())
                  }
                  btnRefresh
                  onRefresh={async () => {
                    if (activeTab === 'tabOne') {
                      await getOuputs();
                    } else {
                      await getMasks();
                    }
                    AlertService.toastSuccess('¡Éxito! Información actualizada.');
                  }}
                  btnBack
                  title={activeTab === 'tabOne' ? 'Salidas' : 'Máscaras'}
                  titleBolder="SMS"
                  subtitle={`Configura y gestiona tus ${activeTab === 'tabOne' ? 'salidas' : 'máscaras'}.`}
                  breadcrumbItems={['Operaciones', 'Canales', 'SMS']}
                  textButton={activeTab === 'tabOne' ? 'Agregar salida' : 'Agregar máscara'}
                  iconButton="ki-soft-2"
                  tabs={tabSMS}
                  onTabChange={setActiveTab}
                />
                <div className="card mb-5 mb-xl-10">
                  <div className="card-header align-items-center border-0 mt-5">
                    <div className="card-title align-items-start flex-column animate-fadeInUp animate-delay-1 h3">
                      <span className="fw-bolder fw-bold fs-2">{t('channels.rcs.list')}</span>
                      <span className="text-gray-700 mt-2 fw-semibold fs-6">
                        {activeTab === 'tabOne' ? t('channels.rcs.outputs') : 'Máscaras'}
                      </span>
                    </div>
                    <div className="card-toolbar"></div>
                  </div>
                  <div className="card-body pt-1">
                    {activeTab === 'tabOne' && (
                      <Datatable columns={columnsOutputs} data={outputs} isLoading={isRequesting} />
                    )}
                    {activeTab === 'tabTwo' && (
                      <Datatable columns={columnsMasks} data={masks} isLoading={isRequesting} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <OutputsModal
        providers={providers}
        show={showModalOutputs.show}
        payload={showModalOutputs.data}
        onRequestClose={(refresh: any) => handleShowModalChannel(refresh)}
      />
      <MasksModal
        show={showModalAgent.show}
        provider={providers}
        payload={showModalAgent.data}
        masks={masksCatalogue}
        onRequestClose={(refresh: any) => handleShowModalAgent(refresh)}
      />
      <SendMessageModalSMS
        show={showModalSendMessage.show}
        onRequestClose={(refresh: any) => handleShowModalSendMessage(refresh)}
        payload={showModalSendMessage.data}
      />
    </>
  );
}

export default ChannelSMSPage;
